<mat-card>
     <div class="d-flex align-items-center justify-content-center position-relative">
            <div style="flex: 1; text-align: center;">
                <mat-card-title style="margin: 0;">Agregar Bienes</mat-card-title>
            </div>
            <button mat-icon-button color="warn" aria-label="Cerrar" (click)="onButtonClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    <mat-card-content *ngIf="!isLoading">
        <form (keydown.enter)="preventSubmit($event)" #form="ngForm" class="col-12" [formGroup]="formAssets"
            (ngSubmit)="save(form)">
            <div class="row align-items-center">
                <ng-container *ngIf="!origin">
                    <mat-form-field appearance="legacy" class="col-12">
                        <mat-label>Origen</mat-label>
                        <mat-select formControlName="origin" [required]>
                            <mat-option *ngFor="let origin of origins" [value]="origin">
                                {{origin.value}}
                            </mat-option>
                        </mat-select>
                        <mat-progress-bar class="over-head" mode="indeterminate" *ngIf="!origins"></mat-progress-bar>
                        <mat-error *ngIf="formAssets.get('origin').hasError('required')">
                            Debe seleccionar el origen</mat-error>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="formAssets.get('origin').value">
                    <ng-container>
                        <mat-form-field appearance="legacy" class="col-12">
                            <mat-label>Tipo Artículo</mat-label>
                                <input matInput formControlName="typeProduct" [matAutocomplete]="auto" required />
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let value of listTypesProductFiltered" [value]="value">
                                    {{ value.account._id == 511114 ? value.accountUnspsc.description + ' - Consumo' : value.accountUnspsc.description }}
                                </mat-option>
                                </mat-autocomplete>
                            <mat-progress-bar class="over-head" mode="indeterminate"
                                *ngIf="!listTypesProduct"></mat-progress-bar>
                            <mat-error *ngIf="formAssets.get('typeProduct').hasError('required')">
                                Debe seleccionar el tipo de articulo</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('description').enabled">
                        <mat-form-field appearance="legacy" class="col-12" *ngIf="formAssets.get('origin').value?.key === 'DOTACION'">
                            <mat-label>Detalle del Producto (de Acta)</mat-label>
                            <input matInput formControlName="prefixDescription" [matAutocomplete]="autoPrefix" required placeholder="Escriba para buscar" />
                            <mat-autocomplete #autoPrefix="matAutocomplete">
                                <mat-option *ngFor="let option of prefixOptionsFiltered" [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="formAssets.get('prefixDescription').hasError('required')">
                                El detalle del producto es obligatorio</mat-error>
                            <mat-error *ngIf="formAssets.get('prefixDescription').hasError('invalidOption')">
                                Debe seleccionar un detalle válido de la lista</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="legacy" class="col-12">
                            <textarea matInput formControlName="description" placeholder="Descripción del artículo"
                                required></textarea>
                            <mat-error *ngIf="formAssets.get('description').hasError('required')">
                                La descripción es obligatoria</mat-error>
                            <mat-error *ngIf="formAssets.get('description').hasError('maxlength')">
                                El máximo de caracteres válidos es de 240</mat-error>
                            <mat-hint
                                *ngIf="formAssets.get('description').value && formAssets.get('description').value.length"
                                align="end">{{formAssets.get('description').value ?
                                formAssets.get('description').value.length : 0}}
                                /240</mat-hint>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('acquisitionDate').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Fecha Adquisición</mat-label>
                            <input matInput formControlName="acquisitionDate" [matDatepicker]="datetimePicker"
                                (click)="datetimePicker.open()" (keydown)="false" [required]="true" [max]="maxDate" [min]="minDate"
                                readonly>
                            <mat-datepicker-toggle matSuffix [for]="datetimePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datetimePicker></mat-datepicker>
                            <button mat-icon-button matSuffix type="button" color="warn"
                                (click)="removeItem('acquisitionDate')">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </ng-container>

                     <ng-container>
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Valor unitario (Con IVA incluido si aplica)</mat-label>
                            <span [class.disabled]="!formAssets.get('value').enabled"
                                *ngIf="formAssets.get('value').value" class="prefix-inp-form">$</span>
                            <input matInput formControlName="value" appCurrencyDirective
                                (valueChange)="fireCurrency($event)"
                                [class.inp-currency]="formAssets.get('value').value" required>
                            <mat-error *ngIf="formAssets.get('value').hasError('min')">
                                El valor unitario debe ser mayor a $0,00</mat-error>
                            <mat-error *ngIf="formAssets.get('value').hasError('exceedsAvailable')">
                                El valor del bien no puede ser mayor a {{ maxValue | currency}}</mat-error>
                        </mat-form-field>
                        
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('quantity').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Cantidad</mat-label>
                            <input matInput formControlName="quantity" appNumberDirective required>
                            <mat-error *ngIf="formAssets.get('quantity').hasError('min')">
                                La cantidad debe ser mayor a 1</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('withMark').enabled">
                        <div class="align-items-center col-12 col-md-6">
                            <mat-slide-toggle color="primary" formControlName="withMark">Articulo sin
                                marca</mat-slide-toggle>
                        </div>
                    </ng-container>

                     <ng-container *ngIf="formAssets.get('mark').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Marca</mat-label>
                             <input matInput formControlName="mark" [matAutocomplete]="autoMark" required/>
                                <mat-autocomplete #autoMark="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let value of listMarksFiltered" [value]="value">
                                    {{value.trademarkName}}
                                </mat-option>
                                </mat-autocomplete>
                            <mat-progress-bar class="over-head" mode="indeterminate"
                                *ngIf="!listMarks"></mat-progress-bar>
                            <mat-error *ngIf="formAssets.get('mark').hasError('required')">
                                Debe seleccionar la marca</mat-error>
                            <mat-error *ngIf="formAssets.get('mark')?.hasError('notObject')">
                            Debe seleccionar una marca de la lista</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('withSerial').enabled">
                        <div class="align-items-center col-12 col-md-6">
                            <mat-slide-toggle color="primary" formControlName="withSerial">No tiene número de
                                serial</mat-slide-toggle>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('serialNumber').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <textarea matInput formControlName="serialNumber" placeholder="Número Serial"
                                required></textarea>
                            <mat-error *ngIf="formAssets.get('serialNumber').hasError('required')">
                                El número de serial es obligatorio</mat-error>
                            <mat-error *ngIf="formAssets.get('serialNumber').hasError('maxlength')">
                                El máximo de caracteres válidos es de 70</mat-error>
                            <mat-hint
                                *ngIf="formAssets.get('serialNumber').value && formAssets.get('serialNumber').value.length"
                                align="end">{{formAssets.get('serialNumber').value ?
                                formAssets.get('serialNumber').value.length : 0}}
                                /70</mat-hint>
                            <mat-error *ngIf="formAssets.get('value').hasError('min')">
                                El mínimo de caracteres válidos es de 6</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('state').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Estado</mat-label>
                            <mat-select formControlName="state" [required]>
                                <mat-option *ngFor="let state of states" [value]="state">
                                    {{state.value}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formAssets.get('state').hasError('required')">
                                Debe seleccionar el estado</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('originalAsset').enabled">
                        <mat-form-field class="col-12">
                            <mat-label>Bien Original</mat-label>
                            <input matInput formControlName="originalAsset" readonly style="cursor:pointer;"
                                placeholder="Selecciona el bien" [required]="true">
                            <button mat-icon-button matSuffix type="button" aria-label="Agregar"
                                (click)="selectAssets()">
                                <mat-icon matTooltip="Agregar">playlist_add</mat-icon>
                            </button>
                            <button mat-icon-button matSuffix type="button" color="warn" aria-label="Cerrar"
                                (click)="removeItem('originalAsset')">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </ng-container>
                </ng-container>
            </div>
        </form>
        <div class="d-flex justify-content-end">
            <ng-container *ngIf="formAssets.get('origin').value && formAssets.get('quantity').enabled && formAssets.get('quantity').value > 1">
                <mat-card-title> Valor Total: {{ calculateTotal() | currency }}</mat-card-title>
            </ng-container>
        </div>
        <div *ngIf="!block && formAssets.get('origin').value" class="d-flex justify-content-end">
            <button mat-raised-button matTooltip="Cancelar" class="mx-2" (click)="cancel()">
                Cancelar
            </button>
            <button mat-raised-button matTooltip="Guardar" color="primary" (click)="save(form)"
                [disabled]="formAssets.invalid">
                Agregar
            </button>
        </div>
    </mat-card-content>
</mat-card>